// Date-range presets for the reports page. Mirrors the Session Reports
// presets (SessionHistoryFilters DATE_RANGES) and their Monday-aligned math
// (StudentActivity resolveDateRange) — copied rather than imported so this
// page doesn't pull whole page modules into its bundle.
export const DEFAULT_DATE_MODE = "this_school_year";

export const DATE_RANGE_OPTIONS = [
  { value: "last_4_weeks", label: "Last 4 weeks" },
  { value: "last_8_weeks", label: "Last 8 weeks" },
  { value: "this_school_year", label: "This School Year" },
  { value: "all_time", label: "All Time" },
  { value: "custom", label: "Custom" },
];

const toIso = (d) => d.toISOString().split("T")[0];

const getMonday = (d) => {
  const day = d.getDay();
  const diff = (day === 0 ? -6 : 1) - day;
  const mon = new Date(d);
  mon.setDate(mon.getDate() + diff);
  return mon;
};

export const resolveDateRange = (preset) => {
  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const monday = getMonday(today);
  const endDate = new Date(monday);
  endDate.setDate(endDate.getDate() + 7);

  switch (preset) {
    case "last_4_weeks": {
      const start = new Date(monday);
      start.setDate(start.getDate() - 21);
      return { start: toIso(start), end: toIso(endDate) };
    }
    case "last_8_weeks": {
      const start = new Date(monday);
      start.setDate(start.getDate() - 49);
      return { start: toIso(start), end: toIso(endDate) };
    }
    case "this_school_year": {
      const year = today.getMonth() >= 7 ? today.getFullYear() : today.getFullYear() - 1;
      return { start: `${year}-08-01`, end: toIso(endDate) };
    }
    case "all_time":
    default:
      return { start: "2020-01-01", end: toIso(endDate) };
  }
};

/**
 * The dates a mode currently stands for: preset math for presets, the picked
 * dates for custom (either may still be empty while the user is choosing).
 */
export const resolveSelectedRange = ({ mode, customStart, customEnd }) => {
  if (mode === "custom") return { start: customStart, end: customEnd };
  return resolveDateRange(mode);
};
